import { createSlice } from "@reduxjs/toolkit";
import { getCHPYParamByName } from "../utils/utils";
import { ENUM_LOCALSTORAGE } from "../components/common/enums";
import { isPhone } from "../components/common/consts";

export const defaultTypeModel = 15;

export const ENUM_MODALS_VALUE = {
  deposit: "deposit",
  premium: "premium",
  typeLogin: "typeLogin",
  private: "private",
  share: "share",
  tipsOffer: "tipsOffer",
  register: "register",
  notify: "notify",
  messageLinkFrame: "messageLinkFrame",
  messageLinkOutsider: "messageLinkOutsider",
  noConnect: "noConnect",
};

const parseLCS = (key, defVal) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || defVal;
  } catch {
    return defVal;
  }
};

const typeModel = getCHPYParamByName("link")
  ? defaultTypeModel
  : +localStorage.getItem(ENUM_LOCALSTORAGE.typeModel) || defaultTypeModel;

const typeSort = getCHPYParamByName("sort-by")
  ? undefined
  : localStorage.getItem(ENUM_LOCALSTORAGE.typeSort) || undefined;

const shown = getCHPYParamByName("show") ? [] : parseLCS(ENUM_LOCALSTORAGE.shown, []);

const commonSlice = createSlice({
  name: "common",
  initialState: {
    isVisible: document.hidden,
    typeModel: typeModel,
    typeSort: typeSort,
    lastFrame: null,
    shown: shown,
    filter: parseLCS(ENUM_LOCALSTORAGE.filter, []),
    nickname: "",
    languagesAll: {},
    maxPage: 2,
    loader: false,
    broadcasters: [],
    broadcastersOnline: [],
    broadcastersPayload: {
      paging: { length: 16, page: 1 },
    },
    languages: [],
    flags: {
      foolScreen: false,
    },
    modals: {
      [ENUM_MODALS_VALUE.deposit]: false,
      [ENUM_MODALS_VALUE.premium]: false,
      [ENUM_MODALS_VALUE.typeLogin]: false,
      [ENUM_MODALS_VALUE.private]: false,
      [ENUM_MODALS_VALUE.cameraSetting]: false,
      [ENUM_MODALS_VALUE.share]: false,
      [ENUM_MODALS_VALUE.register]: false,
      [ENUM_MODALS_VALUE.notify]: false,
      [ENUM_MODALS_VALUE.messageLinkFrame]: false,
      [ENUM_MODALS_VALUE.messageLinkOutsider]: false,
      [ENUM_MODALS_VALUE.noConnect]: false,
      [ENUM_MODALS_VALUE.tipsOffer]: false,
    },
    controls: {
      volume: 100,
      zoom: isPhone() ? 1 : 1.1,
      isFullscreenChat:
        JSON.parse(localStorage.getItem(ENUM_LOCALSTORAGE.isFullscreenChat)) ?? true,
      isShown: true,
      politicMute: false,
    },
  },
  reducers: {
    setTypeModel(state, newAction) {
      localStorage.setItem(ENUM_LOCALSTORAGE.typeModel, newAction.payload);
      state.typeModel = +newAction.payload;
    },
    setSortModel(state, newAction) {
      if (newAction.payload) {
        localStorage.setItem(ENUM_LOCALSTORAGE.typeSort, newAction.payload);
      }
      state.typeSort = newAction.payload;
    },
    setShown(state, newAction) {
      localStorage.setItem(ENUM_LOCALSTORAGE.shown, JSON.stringify(newAction.payload));
      state.shown = newAction.payload;
    },
    setFilter(state, newAction) {
      localStorage.setItem(ENUM_LOCALSTORAGE.filter, JSON.stringify(newAction.payload));
      state.filter = newAction.payload;
    },
    setNickName(state, newAction) {
      state.nickname = newAction.payload;
    },
    setBroadCasters(state, newAction) {
      state.broadcasters = newAction.payload;
    },
    setBroadcastersOnline(state, newAction) {
      state.broadcastersOnline = newAction.payload;
    },
    setBroadcastersPayload(state, newAction) {
      state.broadcastersPayload = newAction.payload;
    },
    setLanguages(state, newAction) {
      const newLanguages = newAction.payload.map((el) => ({
        ...el,
        lang: `${el.code}_${el.country}`,
      }));
      state.languages = newLanguages;
    },

    setModals(state, newAction) {
      const { name, value } = newAction.payload;
      state.modals[name] = value;
    },
    setFlags(state, newAction) {
      const { name, value } = newAction.payload;
      state.flags[name] = value;
    },
    setVolume(state, newAction) {
      state.controls.volume = newAction.payload;
    },
    setZoom(state, newAction) {
      state.controls.zoom = newAction.payload;
    },
    setShownControls(state, newAction) {
      state.controls.isShown = newAction.payload;
    },
    setFullscreenChat(state, newAction) {
      state.controls.isFullscreenChat = newAction.payload;
      localStorage.setItem(ENUM_LOCALSTORAGE.isFullscreenChat, newAction.payload);
    },
    setMaxPage(state, newAction) {
      state.maxPage = newAction.payload;
    },
    setLoader(state, newAction) {
      state.loader = newAction.payload;
    },
    setLanguagesAll(state, newAction) {
      state.languagesAll = newAction.payload;
    },
    setControlPoliticMute(state, newAction) {
      state.controls.politicMute = newAction.payload;
    },
    setIsVisible(state, newAction) {
      state.isVisible = newAction.payload;
    },
    setLastFrame(state, newAction) {
      state.lastFrame = newAction.payload;
    },
  },
});

export default commonSlice.reducer;

export const {
  setTypeModel,
  setSortModel,
  setShown,
  setFilter,
  setNickName,
  setBroadCasters,
  setLanguages,
  setFlags,
  setModals,
  setVolume,
  setZoom,
  setFullscreenChat,
  setShownControls,
  setBroadcastersPayload,
  setBroadcastersOnline,
  setMaxPage,
  setLoader,
  setLanguagesAll,
  setControlPoliticMute,
  setIsVisible,
  setLastFrame,
} = commonSlice.actions;
